import enUS from './en-US/en.json';
import deDE from './de-DE/de.json';

export const localResources: Record<string, Record<string, Record<string, string>>> = {
  'en-US': {
    translation: enUS,
  },
  'de-DE': {
    translation: deDE,
  },
};
